import Vue from "vue";
import { mapGetters } from "vuex";

import { BackorderService, ErrorLogService } from "@/services";

import { LoadingSpinner, StaticFormControl } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";

import { default as SendError } from "./SendError.vue";
import { default as ThankYou } from "./ThankYou.vue";
import { formatDateTime } from "@/components/mixins";

import { IBackorderRowItem, IUserInfo } from "@/types";

export default Vue.extend({
    name: "FollowUp",
    mixins: [inputValidateState, formatDateTime],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        StaticFormControl,
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId"]),
    },
    props: {
        backorder: {
            type: Object,
            required: true,
        },
        showGrid: {
            type: Function,
            required: true,
        },
    },

    data: () => ({
        showThankYou: false,
        showSendError: false,
        isBusy: false,
        truckIsDown: false,
        truckModel: "",
        truckSerial: "",
        message: "",
        errorMessage: "",
        formIsValid: {},
    }),
    updated() {
        this.$validator.validateAll().then((result: any) => {
            this.formIsValid = result;
        });
    },
    methods: {
        async submitFollowUp() {
            try {
                this.showThankYou = false;
                this.isBusy = true;

                var postBodyContent = {
                    backorder: this.backorder,
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    email: this.user.Email,
                    fullName: this.user.FullName,
                    message: this.message,
                    truckIsDown: this.truckIsDown,
                    truckModel: this.truckModel,
                    truckSerial: this.truckSerial
                };
                await BackorderService.submitFollowUp(postBodyContent);

                this.showThankYou = true;
            } catch (err) {
                this.$store.commit("pushTimedMessage", {
                header: "Error sending the request followup. Please contact support or try again.",
                IsError: true,
                seconds: 5
              })
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isBusy = false;
            }
        },
    },
});
